import { AwareHttpService } from '@appbolaget/aware-http';
import { Meta } from '@appbolaget/aware-model';

export class Model {
    public model: string;
    public endpoint: string;

    protected api: AwareHttpService;

    autocompleteLabel?: string;

    defaultFields: any = ['uuid', 'tableLevel', 'created_at', 'updated_at'];
    defaultExcludes: any = [
        'created_at',
        'updated_at',
        'fields',
        'defaultFields',
        'defaultExcludes',
        'excludeFromHttp',
        'searchableFields',
        'children',
        'parent',
        'media',
        'module',
        'hasMeta',
        'sorting',
        'autocompleteLabel',
        'model',
        'endpoint',
        'tableLevel',
    ];

    excludeFromHttp = [];
    fields: any;
    searchableFields: any;
    module = 'cms';

    sorting?: any;
    tableLevel = 0;

    media: Array<File>;
    meta: Array<any> | any;
    hasMeta: boolean;
    createMeta: (key, val) => void;
    deleteMetaByKey: (key) => void;
    setMeta: (meta: any) => void;
    updateMeta: (meta: any) => void;
    getMetaField: (key: string) => Meta;
    getMetaFields: (key: string) => Array<Meta>;
    getMetaFieldValue: (key: string) => string;
    getMetaFieldsValue: (key: string) => Array<string>;

    setMedia: (media: any) => void;
    hasMedia: () => boolean;
    getPrimaryMediaPath: (params?: any) => string;

    uuid?: string;
    created_at?: string;
    updated_at?: string;
    title?: string;
    toDelete?: boolean;
    toCreate?: boolean;
    toUpdate?: boolean;

    constructor() {}

    buildFilterQuery(filter) {
        if (!filter) {
            return '';
        }

        let filterString = '';
        const filterArray = [];

        if (filter.search.length) {
            const searchTerms = filter.search.split(' ');

            for (const field of this.searchableFields) {
                for (const word of searchTerms) {
                    const obj = {};
                    obj[field] = ['like', `%${word}%`];

                    filterArray.push(obj);
                }
            }
        }

        if (filter.filter) {
            if (filterArray.length) {
                for (const obj of filterArray) {
                    Object.assign(obj, filter.filter);
                }
            } else {
                filterArray.push(filter.filter);
            }
        }

        filterString = JSON.stringify(filterArray);

        if (filter.sort) {
            // if (!filterString.length) {
            //     filterString += '[]';
            // }
            filterString += `:sort(${JSON.stringify(filter.sort)})`;
        }

        return filterString;
    }

    initialize(data) {
        this.fields = [...this.fields, ...this.defaultFields];
        this.excludeFromHttp = [...this.excludeFromHttp, ...this.defaultExcludes];

        if (this.fields.includes('meta')) {
            this.meta = [];
        }

        if (data) {
            this.setProperties(data);
        }

        if (this.meta) {
            this.setMeta(this.meta);
        }

        if (this.media && this.media.length) {
            this.setMedia(this.media);
        }

        if (this.fields.includes('meta') && !this.meta) {
            this.meta = [];
        }

        if (this.title) {
            this.autocompleteLabel = this.title;
        }
    }

    injectApi(api) {
        this.api = api;

        return this;
    }

    save(module?: string) {
        const request = this.api.put(this.endpoint, this.getProperties(), this.uuid);

        if (module) {
            request.module(module);
        }

        return request.execute();
    }

    getProperties() {
        const ret = {};

        for (const field of this.fields) {
            if (this.hasOwnProperty(field)) {
                ret[field] = this[field];
            }
        }

        return ret;
    }

    prepare() {
        const fields = this.fields;
        for (const field of this.excludeFromHttp) {
            if (!fields[field]) {
                delete this[field];
            }
        }

        if (this.meta) {
            for (let meta of this.meta) {
                meta = meta.prepare();
            }

            this.meta = JSON.stringify(this.meta);
        }

        return this;
    }

    setProperties(data) {
        for (const field of this.fields) {
            this[field] = data[field];
        }
    }

    get modelName() {
        return this.model;
    }
}
